import { render, staticRenderFns } from "./HomeProfileUpdateBanner.vue?vue&type=template&id=39473b6c&"
import script from "./HomeProfileUpdateBanner.vue?vue&type=script&lang=js&"
export * from "./HomeProfileUpdateBanner.vue?vue&type=script&lang=js&"
import style0 from "./HomeProfileUpdateBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BButton, BRow, BContainer, BJumbotron} from 'bootstrap-vue'
    installComponents(component, {BCol, BButton, BRow, BContainer, BJumbotron})
    

export default component.exports